



















































































































































































































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { decimal, integer, minLength, required, requiredIf } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Toast from '../display/toast.vue';
import { WaterTanksApi } from '@/api';
import { WATER_ENTITY_BILLING_TIERS } from '@/models/ordway';

@Component({
	components: {},
	validations: {
		addNewWaterTankModal: {
			name: {
				required,
				minLength: minLength(1),
				unique(value) {
					return this.addNewWaterTankModalNameUnique;
				},
			},
			nominal: { integer },
			height: { integer },
			offset: { integer },
			location: {
				lat: { decimal },
				lng: { decimal },
			},
			billingTier: { required },
		},
		tankCalc: {
			length: {
				required: requiredIf(function() {
					return ['horCyl', 'rect', 'horOval', 'verOval'].includes(this.addNewWaterTankModalType);
				}),
				integer,
			},
			width: {
				required: requiredIf(function() {
					return ['rect', 'horOval', 'verOval'].includes(this.addNewWaterTankModalType);
				}),
				integer,
			},
			height: {
				required: requiredIf(function() {
					return ['verCyl', 'rect', 'horOval', 'verOval'].includes(this.addNewWaterTankModalType);
				}),
				integer,
			},
			diameter: {
				required: requiredIf(function() {
					return ['horCyl', 'verCyl'].includes(this.addNewWaterTankModalType);
				}),
				integer,
			},
		},
	},
	mixins: [validationMixin],
})
export default class WaterTankForm extends Vue {
	public addNewWaterTankModalNameUnique = true;
	public addNewWaterTankModalType: string = 'verCyl';
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();

	@PropSync('product') public localProduct!: object;
	@PropSync('tanks') public localTanks!: any[];

	public addNewWaterTankModal = {
		name: null,
		nominal: null,
		height: null,
		offset: null,
		location: {
			lat: null,
			lng: null,
		},
		billingTier: null,
	};

	public waterTankTypes: Array<{ value: string; text: string }> = [
		{ value: 'horCyl', text: 'Horizontal Cylinder' },
		{ value: 'verCyl', text: 'Vertical Cylinder' },
		{ value: 'rect', text: 'Rectangle' },
		{ value: 'horOval', text: 'Horizontal Oval' },
		{ value: 'verOval', text: 'Vertical Oval' },
	];

	public tankCalc = {
		length: null,
		width: null,
		height: null,
		diameter: null,
	};

	public calculateNominal() {
		this.$v.tankCalc.$touch();
		if (this.$v.tankCalc.$invalid) {
			new Toast().makeToast(
				'Please make sure you have filled out all required input fields',
				'Invalid Form',
				'danger',
			);
			return;
		}

		const length = this.tankCalc.length || 0;
		const width = this.tankCalc.width || 0;
		const height = this.tankCalc.height || 0;
		const diameter = this.tankCalc.diameter || 0;
		const radius = diameter / 2;
		let vol = 0;
		switch (this.addNewWaterTankModalType) {
			case 'horCyl':
				vol = Math.PI * Math.pow(radius, 2) * length;
				break;
			case 'verCyl':
				vol = Math.PI * Math.pow(radius, 2) * height;
				break;
			case 'rect':
				vol = length * width * height;
				break;
			case 'horOval': {
				const a = width - height;
				vol = (Math.PI * Math.pow(height * 0.5, 2) + 2 * (height * 0.5) * a) * length;
				break;
			}
			case 'verOval': {
				const a = height - width;
				vol = (Math.PI * Math.pow(width * 0.5, 2) + 2 * (width * 0.5) * a) * length;
				break;
			}
		}
		this.addNewWaterTankModal.nominal = Math.round(vol * 0.000001);
	}

	public async addNewWaterTank(e: any) {
		e.preventDefault();
		if (this.addNewWaterTankModal.name && !this.isNameUnique(this.addNewWaterTankModal.name)) {
			this.addNewWaterTankModalNameUnique = false;
			e.preventDefault();
			return;
		}
		this.addNewWaterTankModalNameUnique = true;
		if (!this.addNewItem(e, 'addNewWaterTankModal', 'add-water-tank-modal')) {
			return;
		}

		await this.makeRequest('Water Tank', 'Adding', 'Added', async () => {
			await this.waterTanksApi.addWaterTank({
				data: {
					productId: +this.localProduct.id,
					status: 'install',
					name:
						this.addNewWaterTankModal.name ||
						`Water Tank ${this.localProduct.watertanks.length + 1}`,
					nominal: +(this.addNewWaterTankModal.nominal || 0),
					height: +(this.addNewWaterTankModal.height || 0),
					offset: +(this.addNewWaterTankModal.offset || 0),
					locationLat: +(this.addNewWaterTankModal.location.lat || 0),
					locationLng: +(this.addNewWaterTankModal.location.lng || 0),
					billingTier: this.addNewWaterTankModal.billingTier,
				},
			});
		});
		this.$emit('closeModal');
	}

	public get billingTierOptions() {
		return WATER_ENTITY_BILLING_TIERS;
	}

	public isValid(field: any) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public isNameUnique(name: string | null) {
		return (
			name == null ||
			[
				...this.localProduct.watermeters,
				...this.localProduct.watertanks,
				...this.localProduct.watermonitors,
			].findIndex(entity => entity.name.toLowerCase() === name.toLowerCase()) === -1
		);
	}

	private addNewItem(event: any, modalValidate: string, modal: string): boolean {
		if (this.$v[modalValidate] != null) {
			this.$v[modalValidate].$touch();
			if (this.$v[modalValidate].$invalid) {
				this.submitStatus = 'ERROR';
				event.preventDefault();
				return false;
			}
		}
		this.$emit('closeModal');
		this.$emit('loadProduct');

		this.submitStatus = 'PENDING';
		return true;
	}

	public setLocation(type: string) {
		navigator.geolocation.getCurrentPosition(
			position => {
				this[`addNewWater${type}Modal`].location.lat = +position.coords.latitude || 0;
				this[`addNewWater${type}Modal`].location.lng = +position.coords.longitude || 0;
				const locationValidator = this.$v[`addNewWater${type}Modal`].location;
				if (locationValidator) {
					locationValidator.$touch();
				}
			},
			err => {
				console.log('Failed to get your current location:', err);
				new Toast().makeToast(
					'Failed to get your current location: {reason: err.message || err n}',
					'Geo - Location',
					'Error',
					'danger',
				);
			},
		);
	}

	private async makeRequest(
		type: string,
		actioning: string,
		actioned: string,
		runnable: () => void,
		reload: boolean = true,
	) {
		try {
			await runnable();
		} catch (ex) {
			let error;

			if (ex.response && ex.response.data) {
				error = ex.response.data.message;
			} else if (ex.request) {
				error = 'Network Error';
			} else {
				error = 'Unknown Error';
			}

			new Toast().makeToast(
				`${type} not ${actioned}: ${error}`,
				`Error ${actioning} ${type}`,
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast(`${type} ${actioned}`, 'Success', 'success');
		if (reload) {
			setTimeout(() => this.$emit('loadProduct'), 1000);
		}
	}
}
